import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import useSearchLandUseApplication from "../../../../TCPForms/formComponents/purchasableFAR/farHooks/useSearchLandUseApplication ";
import { setApplicationData } from "@egovernments/digit-ui-module-core/src/redux/actions/formPurchasableFar";
import { fetchLandUseApplication, userEligibility } from "../helpers/helpers";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { bindActionCreators } from "redux";
import { useQuery } from "react-query";
import { departmentList } from "../../../../TCPForms/data";

const SubStep1 = ({
  formData,
  handleSubTabChange,
  t,
  dispatch,
  isUserEligible,
  setIsUserEligible,
  isAssignedLTP,
  officesList,
  applicationFlow,
  tenantId,
  showToast,
  setShowToast,
  isEmployee,
  isApproved,
  userInfo,
}) => {
  const defaultValues = {
    ...formData,
    department: applicationFlow,
  };
  console.log(formData, applicationFlow);
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { handleSubmit, control, reset, watch, setValue, getValues } = useForm({ defaultValues });
  // const [user, setUser] = useState(null);
  const [isAuthorizedSearch, setIsAuthorizedSearch] = useState(false);
  const selectedApplicationNumber = watch("selectedApplication");
  // const selectedFastPasId = watch("land_Id");
  const watchSelectedOffice = watch("selectedOffice")?.split(" ")[0];
  const watchCity = watch("selectedCity");
  console.log("showToastSub1", showToast);
  const { data: applicationData, isLoading: isAppDataLoading, error, refetch } = useQuery(
    ["LandUseData", getValues("land_Id")], // Query key
    () => fetchLandUseApplication(getValues("land_Id")), // Fetch function (which uses the external function)
    {
      enabled: !!getValues("land_Id") && isAuthorizedSearch, // Only run the query if applicationNum is provided
    }
  );
  //const { applicationData, isAppDataLoading, error } = useSearchLandUseApplication(selectedFastPasId);
  const isDA = applicationData?.department === "DA";
  const stateId = Digit.ULBService.getStateId();

  console.log("applicationData", applicationData);
  function userEligibility() {
    if (applicationData?.descriptionOfLand?.landUsesType === "Residential") {
      if (applicationData?.descriptionOfLand?.subLandUseAsPerLayout === "Group Housing") {
        if (applicationData?.descriptionOfLand?.landArea >= 2000) {
          return true;
        }
      }
    } else if (!(applicationData?.descriptionOfLand?.landUsesType === "Residential")) {
      if (applicationData?.descriptionOfLand?.landArea >= 2500) {
        return true;
      }
    } else return false;
  }

  const handleSearchClick = async (applicationNo) => {
    try {
      if (!applicationNo) return;

      setIsAuthorizedSearch(false);

      const response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });

      if (!response?.BPA?.length) {
        setShowToast({
          key: "true",
          error: true,
          message: `No Data Found for this FASTPAS ID...!!`,
        });
        reset({ ...getValues(), land_Id: "" });
        return;
      }

      const data = response?.BPA?.find((item) => item.applicationType === "FORM_LANDUSE");

      if (!data) {
        setShowToast({
          key: "true",
          error: true,
          message: `No data found for this ID...!!`,
        });
        reset({ ...getValues(), land_Id: "" });
        return;
      }

      const uuid = userInfo?.uuid;
      const userDetail = (await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {}))?.user?.[0];

      if (!userDetail || data?.additionalDetails?.professionalInformation?.mobileNumber !== userDetail?.mobileNumber) {
        setShowToast({
          key: "true",
          error: true,
          message: `Not Authorized to access this Id...!!`,
        });
        reset({ ...getValues(), land_Id: "" });
        return;
      }

      setShowToast({
        key: "true",
        error: false,
        message: `Data fetched Successfully...!!`,
      });

      setIsAuthorizedSearch(true);
      Digit.SessionStorage.set("FASTPAS_ID", data);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    if (!isAppDataLoading && applicationData) {
      console.log("fromEffectData", applicationData);

      dispatch(setApplicationData(applicationData, false, null));
    }
  }, [isAppDataLoading, applicationData]);

  useEffect(() => {
    setIsUserEligible(userEligibility());
    setIsUserEligible(true);
    if (applicationData) {
      // setParams(farSessionData);
      const landUseAppNum = sessionStorage.getItem("LandUseAppNum");

      reset({
        ...formData,
        selectedOffice: applicationData?.selectedOffice,
        selectedUnit: applicationData?.selectedUnit,
        selectedCity: applicationData?.selectedCity,
        // selectedApplication: !!landUseAppNum ? landUseAppNum : "",
        land_Id: !!landUseAppNum ? landUseAppNum : "",
        landInfo: { ...formData?.landInfo, owners: formData?.applicationNo ? formData?.landInfo?.owners : null },
      });
      const fetchBusinessService = async () => {
        const result = await Digit.LocationService.getBusinessServices(
          isDA ? watchSelectedOffice : watchCity,
          null,
          "FORM_PURCHASABLE_FAR",
          applicationFlow
        );
        console.log(result, "businessService");
        setValue("businessService", result);
        setValue("landInfo.address.locality.code", isDA ? watchSelectedOffice : watchCity);
        // setValue("landInfo.address.tenantId", tenantId);
      };

      if (watchSelectedOffice || watchCity) {
        fetchBusinessService();
      }
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
      // setValue("documents", applicationData?.documents);
      console.log("appData", applicationData, Boolean(applicationData?.descriptionOfLand?.roadWidths?.[0]?.value));
    }
  }, [applicationData, watchSelectedOffice, watchCity]);
  const onSubmit = (data) => {
    data = {
      ...data,
      department: applicationData?.department,

      professionalInformation: applicationData?.professionalInformation,
      documents: applicationData?.documents,
    };
    console.log("dataFromSub1", data);
    handleSubTabChange(1, data);
  };

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Approved Land Use</h2>
          </div>
          <div className="formInputContainer" style={{ padding: "4px" }}>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS ID"
                  placeholder="Enter FASTPAS ID."
                  name="land_Id"
                  type="textInput"
                  mandatory
                  disabled={isEmployee || isApproved}
                  isApproved={true}
                  defaultValue={applicationData?.land_Id}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("land_Id"))}
                />
              </Col>
              {/* {isUserEligible ? ( */}

              {isDA && applicationData ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label={applicationFlow === "DA" ? "Select Development Authority" : "Select Avas Vikas Parishad"}
                    inputLabel="Select office"
                    placeholder="Select office"
                    name="selectedOffice"
                    disabled={
                      Boolean(isAssignedLTP) ||
                      Boolean(formData?.selectedOffice) ||
                      Boolean(applicationData?.selectedOffice || isEmployee || isApproved)
                    }
                    type="selectInput"
                    data={officesList}
                    defaultValue={applicationData?.selectedOffice}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <React.Fragment>
                  {<Col></Col>}
                  {/* {applicationData && <div>Land Use details do not match the eligibility criteria.</div>} */}
                </React.Fragment>
              )}
            </Row>
            {!isDA && applicationData && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select Unit"}
                    inputLabel="Select unit"
                    placeholder="Select unit"
                    name="selectedUnit"
                    type="selectInput"
                    mandatory
                    ddisabled={
                      Boolean(isAssignedLTP) || Boolean(formData?.selectedUnit) || Boolean(applicationData?.selectedUnit || isEmployee || isApproved)
                    }
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select City"}
                    inputLabel="Select city"
                    placeholder="Select city"
                    name="selectedCity"
                    type="selectInput"
                    disabled={
                      Boolean(isAssignedLTP) || Boolean(formData?.selectedCity) || Boolean(applicationData?.selectedCity || isEmployee || isApproved)
                    }
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}
          </div>
          {isUserEligible && (
            <div className="footerContainer2">
              <div className="buttonWrapper">
                {!isEmployee && !isApproved && (
                  <ButtonWrapper
                    variant="contained"
                    color="success"
                    size="medium"
                    label="Save"
                    type="submit"
                    disabled={isAppDataLoading}
                    sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </form>
    </section>
  );
};

export default SubStep1;
